// import { Controller } from '@hotwired/stimulus';

// // Connects to data-controller="video-modal"
// // This controller shows, hides, and plays the website video
// export default class extends Controller {
//   static targets = ['modal', 'videoContainer', 'video'];
//   connect() {
//     console.log('video modal controller connected');
//   }

//   showModal(event) {
//     this.modalTarget.classList.remove('hidden');
//   }

//   playVideo(event) {
//     // prevent modal closing
//     event.stopImmediatePropagation();
//   }

//   openFullscreen(event) {
//     let context = this;
//     context.videoTarget.addEventListener(
//       'fullscreenchange',
//       function (event) {
//         if (!document.fullscreenElement) {
//           context.videoTarget.pause();
//         } else {
//           context.videoTarget.muted = false;
//           context.videoTarget.play();
//         }
//       },
//       false
//     );
//     if (context.videoTarget.requestFullscreen) {
//       context.videoTarget.requestFullscreen();
//     } else if (context.videoTarget.webkitRequestFullscreen) {
//       /* Safari */
//       context.videoTarget.webkitRequestFullscreen();
//     } else if (context.videoTarget.msRequestFullscreen) {
//       /* IE11 */
//       context.videoTarget.msRequestFullscreen();
//     }
//   }

//   hideModal(event) {
//     // hide the video modal
//     // remove and re-add video source to stop playing in background
//     this.modalTarget.classList.add('hidden');
//     this.videoContainerTarget.innerHTML = '';
//     this.videoContainerTarget.innerHTML = `
//     <video height="300" width="450" alt="iRock introduction video" class="absolute w-full h-full" data-video-modal-target="video" controls="controls" poster="https://res.cloudinary.com/doavb6txr/video/upload/f_auto,q_60,so_0.26/How_does_iRock_Work.jpg"><source src="https://res.cloudinary.com/doavb6txr/video/upload/f_auto,q_60,so_0.26/How_does_iRock_Work.webm" type="video/webm"><source src="https://res.cloudinary.com/doavb6txr/video/upload/f_auto,q_60,so_0.26/How_does_iRock_Work.mp4" type="video/mp4"><source src="https://res.cloudinary.com/doavb6txr/video/upload/f_auto,q_60,so_0.26/How_does_iRock_Work.ogv" type="video/ogg">Your browser does not support HTML5 video tags</video>
//     `;
//   }

//   hideModalCareers(event) {
//     // hide the video modal
//     // remove and re-add video source to stop playing in background
//     this.modalTarget.classList.add('hidden');
//     this.videoContainerTarget.innerHTML = '';
//     this.videoContainerTarget.innerHTML = `
//     <video height="300" width="450" alt="iRock introduction video" class="absolute w-full h-full" data-video-modal-target="video" controls="controls" poster="https://res.cloudinary.com/doavb6txr/video/upload/f_auto,q_auto,so_0.26/Become_an_iRock_Band_Coach.jpg"><source src="https://res.cloudinary.com/doavb6txr/video/upload/f_auto,q_auto,so_0.26/Become_an_iRock_Band_Coach.webm" type="video/webm"><source src="https://res.cloudinary.com/doavb6txr/video/upload/f_auto,q_auto,so_0.26/Become_an_iRock_Band_Coach.mp4" type="video/mp4"><source src="https://res.cloudinary.com/doavb6txr/video/upload/f_auto,q_auto,so_0.26/Become_an_iRock_Band_Coach.ogv" type="video/ogg">Your browser does not support HTML5 video tags</video>
//     `;
//   }
// }
